<template>
  <div>
    <div
      class="bg-white shadow-sm py-3 my-2"
      style="border-radius: 10px"
      id="contract_page"
    >
      <div class="d-flex align-items-center px-3">
        <div class="ml-auto">
          <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 -960 960 960"
              width="24px"
              fill="#00bea5"
          >
            <path d="M0 0h24v24H0z" fill="none" />
              <path d="M240-80q-50 0-85-35t-35-85v-120h120v-560h600v680q0 50-35 85t-85 35H240Zm480-80q17 0 28.5-11.5T760-200v-600H320v480h360v120q0 17 11.5 28.5T720-160ZM360-600v-80h360v80H360Zm0 120v-80h360v80H360ZM240-160h360v-80H200v40q0 17 11.5 28.5T240-160Zm0 0h-40 400-360Z"/>

          </svg>
          <span class="pr-2">قرارداد های من</span>
        </div>
      </div>
      <hr />
      <div class="px-2">
        <div class="table-responsive">
          <table class="table table-borderless text-center">
            <thead>
              <tr>
                <th scope="col" style="background-color: #eee; border-radius: 0 16px 16px 0"
                >
                    {{ $t('online_contract.columns.id')}}
                </th>
                <th scope="col" style="background-color: #eee">
                    {{ $t('online_contract.columns.title')}}
                </th>
                <th scope="col" style="background-color: #eee">
                    {{ $t('online_contract.columns.created_at')}}
                </th>
                <th scope="col" style="background-color: #eee">
                    {{ $t('online_contract.columns.sign_date')}}
                </th>
                <th scope="col" style="background-color: #eee">
                    {{ $t('online_contract.columns.status')}}
                </th>
                <th scope="col" style="background-color: #eee; border-radius: 16px 0 0 16px">

                    {{ $t('online_contract.columns.actions')}}
                </th>

              </tr>
            </thead>
            <tbody>
              <tr v-for="(contract, index) in contracts" :key="index">
                  <td class="text-white-in-dark-mode" v-text="contract.id"></td>
                  <td class="text-white-in-dark-mode" v-text="contract.contract_title"></td>
                  <td class="text-white-in-dark-mode" v-text="contract.created_at"></td>
                  <td class="text-white-in-dark-mode" v-text="contract.signed_date"></td>
                  <td class ='text-white-in-dark-mode'>
                      <div v-text="getStatusText(contract.status)"
                            :class="['p-2','badge' ,'badge-' + getStatusStyle(contract.status)]"
                      ></div>
                  </td>
                  <td>
                      <RouterLink
                          class="btn p-0 m-0 text-white-in-dark-mode"
                          :to="{ name: 'show_contract', params: {hashid: contract.id} }"
                      >
                      <span class="special-tooltip btn btn-sm btn-clean btn-icon btn-icon-sm">
                          <span class="tooltip-text">مشاهده</span>
                          <span>
                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#615C5C"><path d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z"/></svg>
                          </span>
                      </span>
                      </RouterLink>
                          <button
                              class="btn p-0 m-0 text-white-in-dark-mode"
                              @click="downloadContract(contract.id)"
                              v-if="contract.status !== contractStatus.PENDING"
                          >
                                <span class="special-tooltip btn btn-sm btn-clean btn-icon btn-icon-sm">
                                    <span class="tooltip-text">دانلود فایل امضاء شده</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#78A75A"><path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h200v80H160v480h640v-480H600v-80h200q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm320-184L280-544l56-56 104 104v-304h80v304l104-104 56 56-200 200Z"/></svg>
                                </span>
                          </button>
                          <button
                              class="btn p-0 m-0 text-white-in-dark-mode"
                              @click="downloadContract(contract.id)"
                              v-else
                          >
                            <span class="special-tooltip btn btn-sm btn-clean btn-icon btn-icon-sm">
                                <span class="tooltip-text">دانلود</span>
                                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#48752C"><path d="M480-320 280-520l56-58 104 104v-326h80v326l104-104 56 58-200 200ZM240-160q-33 0-56.5-23.5T160-240v-120h80v120h480v-120h80v120q0 33-23.5 56.5T720-160H240Z"/></svg>
                            </span>
                          </button>
                      <button
                          class="btn p-0 m-0 text-white-in-dark-mode"
                      >
                        <span class="special-tooltip btn btn-sm btn-clean btn-icon btn-icon-sm">
                            <span class="tooltip-text">در صورت نیاز به اصلاح قرارداد لطفا پس از ثبت نظرات خود در فایل قرارداد، ان را از طریق تیکت به واحد حقوقی ارسال کنید</span>
                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5985E1"><path d="M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>                        </span>
                      </button>
                  </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
      <div v-if="pending_count > 0" class="py-2 px-2">
          <p class="font-weight-bold">
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#F19E39"><path d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Zm40 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
              <span>
              جهت ادامه استفاده از خدمات ما، لازم است قرارداد کاربری را مطالعه و امضا کنید.
              </span>
          </p>
      </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { contractStatus, contractStatusStr, contractStatusVariant } from '@/constants/onlineContract';
import { ApiUrl } from '@/common/api.service';
import axios from 'axios';
import { i18n } from '@/plugins/i18n';

export default {
  name: "online-contracts",
  computed: {
      contractStatus() {
          return contractStatus
      },
    ...mapGetters('onlineContract', ['contracts', 'pending_count']),
  },
  mounted() {
    this.$store.dispatch("onlineContract/getUserContracts");
    this.$store.dispatch("user/fetchCurrent");
  },
  data() {
    return {
    };
  },
  methods: {
      getStatusText(status){
          return contractStatusStr.get(status)
      },
      getStatusStyle(status){
          return contractStatusVariant(status)
      },
      downloadContract(id) {
          axios({
              url: ApiUrl.path('online-contract/contract/download/' + id),
              method: 'GET',
              responseType: 'blob',
          })
              .then(
                  response => {
                      const blob = new Blob([response.data], { type: 'application/pdf' });
                      const fileLink = document.createElement('a');
                      fileLink.href = window.URL.createObjectURL(blob);
                      fileLink.setAttribute('download', id + 'contract.pdf');
                      document.body.appendChild(fileLink);
                      fileLink.click();
                      document.body.removeChild(fileLink);
                  },
                  error => {
                      this.toastr.error(i18n.t('reports.tax.failedMessage'))
                  });
      },
      downloadSignedContract(id) {
          axios({
              url: ApiUrl.path('online-contract/contract/download-signed/' + id),
              method: 'GET',
              responseType: 'blob',
          })
              .then(
                  response => {
                      const blob = new Blob([response.data], { type: 'application/pdf' });
                      const fileLink = document.createElement('a');
                      fileLink.href = window.URL.createObjectURL(blob);
                      fileLink.setAttribute('download', id + 'contract-signed.pdf');
                      document.body.appendChild(fileLink);
                      fileLink.click();
                      document.body.removeChild(fileLink);
                  },
                  error => {
                      this.toastr.error(i18n.t('reports.tax.failedMessage'))
                  });
      }
  },
};
</script>

<style scoped>
</style>